document.addEventListener('DOMContentLoaded', function () {

  // ---- INLINE ADV ----
  var countP = document.querySelectorAll('#echo_detail p:not(table p, blockquote p)');
  function insertBefore(newNode, dist) {
    dist.parentNode.insertBefore(newNode, dist);
  }
  // ---- JO pos ----
  if (document.getElementById('inline_0st')) {
    if (countP.length > 2) {
      var adv = document.getElementById('inline_0st');
      insertBefore(adv, countP[1]);
    } else {
      document.getElementById('inline_0st').style.display = "none";
    }
  }
  if (document.getElementById('inline_element')) {
    if (countP.length > 3) {
      var adv = document.getElementById('inline_element');
      insertBefore(adv, countP[3]);
    } else {
      document.getElementById('inline_element').style.display = "none";
    }
  }
  if (document.getElementById('inline_element3')) {
    if (countP.length > 2) {
      var adv = document.getElementById('inline_element3');
      insertBefore(adv, countP[1]);
    } else {
      document.getElementById('inline_element3').style.display = "none";
    }
  }
  // ---- J1 pos ----
  if (document.getElementById('inline_1st')) {
    if (countP.length > 6) {
      var adv = document.getElementById('inline_1st');
      insertBefore(adv, countP[5]);
    } else {
      document.getElementById('inline_1st').style.display = "none";
    }
  }
  // ---- J2 pos ----
  // if (document.getElementById('inline_2st')) {
  //   if (countP.length > 4) {
  //     var adv = document.getElementById('inline_2st');
  //     insertBefore(adv, countP[4]);
  //   } else {
  //     document.getElementById('inline_2st').style.display = "none";
  //   }
  // }
  // // ---- J3 pos ----
  // if (document.getElementById('inline_3st')) {
  //   if (countP.length > 5) {
  //     var adv = document.getElementById('inline_3st');
  //     insertBefore(adv, countP[5]);
  //   } else {
  //     document.getElementById('inline_3st').style.display = "none";
  //   }
  // }
  // // ---- J4 pos ----
  // if (document.getElementById('inline_4st')) {
  //   if (countP.length > 6) {
  //     var adv = document.getElementById('inline_4st');
  //     insertBefore(adv, countP[6]);
  //   } else {
  //     document.getElementById('inline_4st').style.display = "none";
  //   }
  // }
  //   // ---- J5 pos ----
  // if (document.getElementById('inline_5st')) {
  //   if (countP.length > 8) {
  //     var adv = document.getElementById('inline_5st');
  //     insertBefore(adv, countP[8]);
  //   } else {
  //     document.getElementById('inline_5st').style.display = "none";
  //   }
  // }

  //---------- LIGHT GALLERY FOR ATTACH ----------
  if (document.querySelectorAll("#imageGalleryAttach")) {
    let gallery = document.querySelectorAll("#imageGalleryAttach");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true
      });
    });
  }
  //---------- END OF LIGHT GALLERY ----------


  //---------- LIGHT GALLERY FOR INLINE GALLERY ----------
  if (document.querySelectorAll("#inline_gallery_slider")) {
    let gallery = document.querySelectorAll("#inline_gallery_slider");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true
      });
    });
  }
  //---------- END OF LIGHT GALLERY ----------

  // ---- SEARCH TOGGLE ----
  var slideOpen = true;
  if (window.screen.width < 880) {
    document.querySelector('#click_to_search').addEventListener('click', function () {
      var searchForm = document.querySelector('.search_box form');
      if (slideOpen) {
        slideOpen = false;
        searchForm.style.height = '30px';
      }
      else {
        slideOpen = true;
        searchForm.style.height = '0px';
      }
    })
  }
  //MENU TOGGLE
  if (window.screen.width < 900) {
    // ----- MENU -----
    var menu = document.querySelector('.header_middle_left .show_menu');
    menu.addEventListener('click', toggleMenu);
    function toggleMenu() {
      var menuForm = document.querySelector('#nav_toggle');
      if (menuForm.style.display === "block") {
        menuForm.style.display = "none"

      } else {
        menuForm.style.display = "block"
      }
    }
    // ----- END OF MENU -----
    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function (i) {
      i.addEventListener('click', toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.parentNode.children[2].style.display === "block") {
          this.parentNode.children[2].style.display = "none";
        } else {
          this.parentNode.children[2].style.display = "block";
        }
      }
    })
    // ----- END OF SUB_MENU -----
  }
  //---------RESPONSIVE TABLE---------
  if (window.screen.width < 900) {
    if (document.querySelector("#echo_detail")) {
      var tables = document.querySelectorAll("#echo_detail table");
      tables.forEach(function (table) {
        var parentTable = document.createElement('div');
        parentTable.classList.add("table_res");
        table.parentNode.replaceChild(parentTable, table);
        parentTable.appendChild(table);
      });
    }
  }
  //----------GALLERY SLIDER---------
  // const galleryAttach = document.getElementById('gallery_attach');
  // if (galleryAttach) {
  //   new Splide( '#gallery_attach', {
  //     direction:'rtl',
  //     type: 'loop',
  //   }).mount();
  // }
  // const galleryinline = document.getElementsByClassName('inline_gallery');
  // if (galleryinline) {
  //   for (const element of galleryinline) {
  //     new Splide( element, {
  //       direction:'rtl',
  //       type: 'loop',
  //     }).mount();
  //   }
  // }

  //---------END MESSAGE------
  if (document.querySelectorAll(".end_msg_txt").length) {
    var endmsg = document.querySelector(".end_msg_txt").textContent;
    var contentTextParagraphs = document.querySelectorAll("#echo_detail p");
    var lastParagraph = contentTextParagraphs[contentTextParagraphs.length - 1];

    var anchor = document.createElement("a");
    anchor.href = 'http://t.me/fartaknews';
    anchor.title = 'telegramChannel';
    anchor.className = 'endmsg_addbyjs';
    anchor.textContent = endmsg;

    lastParagraph.appendChild(anchor);
  }

  //SHORT LINK
document.querySelectorAll(".share_link, .share_link2").forEach(function(el) {
  el.addEventListener("click", function (event) {
    event.preventDefault();

    navigator.clipboard.writeText(el.href).then(function () {
      document.querySelector(".copied").style.display = "block";
      setTimeout(function () {
        document.querySelector(".copied").style.display = "none";
      }, 1500);
    });
  });
});
  if (document.getElementById('tinyurl')) {
    document.getElementById('tinyurl').addEventListener('click', function () {
      document.querySelector('.copySho').select();
      document.execCommand("Copy");
      document.querySelector('.short_link .copiedd').style.display = 'block'
      setTimeout(function () {
        document.querySelector('.short_link .copiedd').style.display = 'none'
      }, 2000);
    })
  }

  if (document.getElementById("plusme")) {
    document.getElementById("plusme").addEventListener("click", function () {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "/rates/score/?type=%2B&object_master_id=" + newsMasterIdForRate, true);

      xhr.onload = function () {
        if (xhr.status === 200) {
          var newScore = JSON.parse(xhr.responseText);
          document.getElementById("plusme").innerHTML = "<span>" +
            newScore["plus"] +
            ` <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path fill="#098b54" d="m15 10l-.493-.082A.5.5 0 0 0 15 10.5zM4 10v-.5a.5.5 0 0 0-.5.5zm16.522 2.392l.49.098zM6 20.5h11.36v-1H6zm12.56-11H15v1h3.56zm-3.067.582l.806-4.835l-.986-.165l-.806 4.836zM14.82 3.5h-.213v1h.213zm-3.126 1.559L9.178 8.832l.832.555l2.515-3.774zM7.93 9.5H4v1h3.93zM3.5 10v8h1v-8zm16.312 8.49l1.2-6l-.98-.196l-1.2 6zM9.178 8.832A1.5 1.5 0 0 1 7.93 9.5v1a2.5 2.5 0 0 0 2.08-1.113zm7.121-3.585A1.5 1.5 0 0 0 14.82 3.5v1a.5.5 0 0 1 .494.582zM18.56 10.5a1.5 1.5 0 0 1 1.471 1.794l.98.196a2.5 2.5 0 0 0-2.45-2.99zm-1.2 10a2.5 2.5 0 0 0 2.452-2.01l-.98-.196A1.5 1.5 0 0 1 17.36 19.5zm-2.754-17a3.5 3.5 0 0 0-2.913 1.559l.832.554a2.5 2.5 0 0 1 2.08-1.113zM6 19.5A1.5 1.5 0 0 1 4.5 18h-1A2.5 2.5 0 0 0 6 20.5z"/><path stroke="#098b54" d="M8 10v10"/></g>
        </svg>` +
            "</span>";
          // console.log(newScore);
        }
      };

      xhr.send();
    });
  }


  if (document.getElementById("minusme")) {
    document.getElementById("minusme").addEventListener("click", function () {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", "/rates/score/?type=-&object_master_id=" + newsMasterIdForRate, true);

      xhr.onload = function () {
        if (xhr.status === 200) {
          var newScore = JSON.parse(xhr.responseText);
          document.getElementById("minusme").innerHTML = "<span>" +
            newScore["minus"] +
            `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path fill="#B40C00" d="m15 14l-.493.082A.5.5 0 0 1 15 13.5zM4 14v.5a.5.5 0 0 1-.5-.5zm16.522-2.392l.49-.098zM6 3.5h11.36v1H6zm12.56 11H15v-1h3.56zm-3.067-.582l.806 4.835l-.986.165l-.806-4.836zM14.82 20.5h-.213v-1h.213zm-3.126-1.558l-2.515-3.774l.832-.555l2.515 3.774zM7.93 14.5H4v-1h3.93zM3.5 14V6h1v8zm16.312-8.49l1.2 6l-.98.196l-1.2-6zM9.178 15.168A1.5 1.5 0 0 0 7.93 14.5v-1a2.5 2.5 0 0 1 2.08 1.113zm7.121 3.585a1.5 1.5 0 0 1-1.48 1.747v-1a.5.5 0 0 0 .494-.582zM18.56 13.5a1.5 1.5 0 0 0 1.471-1.794l.98-.196a2.5 2.5 0 0 1-2.45 2.99zm-1.2-10a2.5 2.5 0 0 1 2.452 2.01l-.98.196A1.5 1.5 0 0 0 17.36 4.5zm-2.754 17a3.5 3.5 0 0 1-2.913-1.558l.832-.555a2.5 2.5 0 0 0 2.08 1.113zM6 4.5A1.5 1.5 0 0 0 4.5 6h-1A2.5 2.5 0 0 1 6 3.5z"/><path stroke="#B40C00" d="M8 14V4"/></g>
      </svg>` +
            "</span>";
          // console.log(newScore);
        }
      };

      xhr.send();
    });
  }
  // ---------------------TAB BOX -------------------------
  var tabHeader = document.querySelectorAll(
    ".multi_tab .tabs li"
  );
  tabHeader.forEach(function (item) {
    item.addEventListener("click", function (e) {
      if (!item.classList.contains("active")) {
        // find index of clicked item
        var tabNum = Array.prototype.indexOf.call(tabHeader, item);
        var nthChild = tabNum + 1;
        // remove active class from all items
        tabHeader.forEach(function (item) {
          item.classList.remove("active");
        });
        // add active class to clicked item
        item.classList.add("active");
        // remove active class from all tab content
        var tabContent = document.querySelectorAll(
          ".tab_content .tab_cont"
        );
        tabContent.forEach(function (item) {
          item.classList.remove("active");
          item.classList.remove("visible");
        });
        // add active class to tab content
        document
          .querySelector(".tab_content .tab_cont:nth-child(" + nthChild + ") ")
          .classList.add("active");
        document
          .querySelector(".tab_content .tab_cont:nth-child(" + nthChild + ") ")
          .classList.add("visible");
      }
    });
  });
  // SLIDER FOR TAB ELEMENTS
  var splideElements = document.querySelectorAll('.splides');
  splideElements.forEach(function (element) {
    new Splide(element, {
      direction: "rtl",
      arrows: false
    }).mount();
  });
  // -------------STICKY NEWS -----------------
  if (document.getElementById("emergency")) {
    const mySticky = document.getElementById("emergencyyy");
    window.onscroll = function () { scrollFunction() };
    function scrollFunction() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        mySticky.classList.add("fixed_emergency_news");
      } else {
        mySticky.classList.remove("fixed_emergency_news");
      }
    }
    document.getElementById("emergency-close").addEventListener("click", function () {
      const emergencyBox = document.getElementById("emergencyyy");
      const display = window.getComputedStyle(emergency).display;
      if (display === "none") {
        emergencyBox.style.display = "block";
      } else {
        emergencyBox.style.display = "none";
      }
    });
  }

  // *.*.*.*.*.*.*.*.*.* show sticky box with scroll *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.getElementsByClassName("sticky_notify_bottom").length > 0) {

    var sticky_notify_bottom = true;
    window.onscroll = function () {
      if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250 && sticky_notify_bottom) {
        document.getElementsByClassName("sticky_notify_bottom")[0].style.opacity = "1";
      }
    };
    document.getElementById("close_stiky_notify_bottom").addEventListener("click", function (e) {
      document.getElementsByClassName("sticky_notify_bottom")[0].style.opacity = "0";
      sticky_notify_bottom = false;
    });
  }
  //---------------END OF STICKY NEWS-------------------


  // //-------------RSSBANK--------------
  // if (document.getElementById("rssbank_container")) {

  //   var domainname = "www.fartaknews.com";
  //   var rsBankEsQ = function (unsafe) {
  //     return unsafe
  //       .replace(/&/g, "&amp;")
  //       .replace(/</g, "&lt;")
  //       .replace(/>/g, "&gt;")
  //       .replace(/"/g, "&quot;")
  //       .replace(/'/g, "&#039;");
  //   };
  //   var rssList = document.getElementById("rssbank_container");
  //   var rssListItems = "";
  //   var rssX = new XMLHttpRequest();
  //   rssX.open("GET", "https://rssbank.ir/links/" + domainname + "/data.json");
  //   rssX.onload = function () {
  //     if (rssX.status === 200) {
  //       var rssData = JSON.parse(rssX.responseText);
  //       rssData.forEach(function (item) {
  //         // console.log(item);
  //         rssListItems +=
  //           "<li class='list_item'>" +
  //           "<div class='content'>" +
  //           `<span>
  //             <svg aria-hidden="true" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  //               <g>
  //                 <path d="M3.50842 8.81111C3.62891 8.7357 3.67016 8.56833 3.60066 8.43759C3.53106 8.30696 3.3769 8.2621 3.25641 8.33751C3.13592 8.41302 3.09457 8.5804 3.16417 8.71103C3.23367 8.84176 3.38793 8.88662 3.50842 8.81111Z" fill="#B40C00"></path>
  //                 <path d="M2.47552 10.6983L3.74462 13.0835C4.01848 13.5988 4.63452 13.7896 5.12171 13.484C5.60377 13.1817 5.76945 12.5134 5.49056 11.9899L4.73454 10.5689L5.38927 10.1587C5.50976 10.0831 5.55111 9.91594 5.48151 9.7852L5.1538 9.16933C5.19288 9.1611 5.44981 9.10641 9.98074 8.14201C10.5409 8.10901 10.8765 7.44432 10.5935 6.91293L9.756 5.33896L10.2912 4.45937C10.3438 4.37285 10.3469 4.26166 10.2992 4.17194L9.79518 3.22473C9.74744 3.13501 9.65677 3.08246 9.56178 3.08855L8.59223 3.15167L7.66246 1.40424C7.52779 1.15109 7.28652 0.997818 7.01718 0.994186C7.01393 0.99408 7.01078 0.99408 7.00754 0.99408C6.74726 0.99408 6.511 1.13464 6.37102 1.3723L3.07896 5.92268L0.938764 7.26338C0.0969973 7.7905 -0.194584 8.96222 0.293091 9.87802C0.738634 10.7154 1.67796 11.0448 2.47552 10.6983ZM5.05418 12.2634C5.19337 12.5247 5.11098 12.859 4.8695 13.0104C4.62724 13.1624 4.31873 13.069 4.18111 12.8102L2.92106 10.4419L3.79404 9.895C5.25234 12.636 5.03075 12.2195 5.05418 12.2634ZM4.48253 10.0952L4.23052 9.62157L4.66701 9.34813L4.91902 9.82173L4.48253 10.0952ZM9.43656 3.6445L9.78484 4.29904L9.47426 4.80939L8.87397 3.68114L9.43656 3.6445ZM6.79254 1.67212C6.86017 1.55206 6.96747 1.53967 7.01098 1.54095C7.054 1.54149 7.1612 1.55602 7.22588 1.67757L10.157 7.18637C10.2525 7.36571 10.1365 7.59119 9.94501 7.59631C9.91065 7.59717 9.8948 7.6039 9.8068 7.62173L6.70621 1.79463C6.77128 1.70384 6.77964 1.69508 6.79254 1.67212ZM6.37082 2.25819L9.28398 7.73303L4.88742 8.6687L3.55059 6.15639L6.37082 2.25819ZM0.729577 9.60458C0.61893 9.39684 0.560456 9.161 0.560456 8.92238C0.560456 8.43468 0.80203 7.98051 1.19077 7.73698L3.15496 6.50652L4.415 8.87453L2.45081 10.1051C1.84905 10.4819 1.07697 10.2574 0.729577 9.60458Z" fill="#B40C00"></path>
  //                 <path d="M2.72759 8.98447C2.65799 8.85374 2.50383 8.80888 2.38334 8.88439L1.94686 9.15783C1.82656 9.23324 1.67211 9.18827 1.60261 9.05775C1.53301 8.92701 1.37885 8.88215 1.25836 8.95766C1.13787 9.03318 1.09653 9.20045 1.16612 9.33118C1.37354 9.72105 1.83621 9.85851 2.19887 9.63143L2.63535 9.35799C2.75584 9.28248 2.79719 9.11532 2.72759 8.98447Z" fill="#B40C00"></path>
  //                 <path d="M12.585 1.57897L11.1808 2.42684C11.0592 2.50032 11.0154 2.66684 11.0831 2.79875C11.1507 2.93056 11.304 2.9783 11.4259 2.90471L12.8301 2.05684C12.9517 1.98335 12.9954 1.81684 12.9277 1.68492C12.8601 1.5529 12.7066 1.50548 12.585 1.57897Z" fill="#B40C00"></path>
  //                 <path d="M12.4375 4.41097L11.4638 4.12792C11.3294 4.08883 11.1912 4.17535 11.1551 4.32125C11.1191 4.46716 11.1989 4.61701 11.3334 4.6561L12.3072 4.93916C12.4424 4.97857 12.58 4.89066 12.6158 4.74583C12.6518 4.59992 12.572 4.44996 12.4375 4.41097Z" fill="#B40C00"></path>
  //                 <path d="M9.99101 0.585533L9.72985 1.64211C9.69382 1.78802 9.77355 1.93787 9.90802 1.97707C10.0424 2.01606 10.1806 1.92976 10.2167 1.78374L10.4778 0.727165C10.5138 0.58126 10.4341 0.431297 10.2996 0.392204C10.1653 0.353111 10.027 0.439628 9.99101 0.585533Z" fill="#B40C00"></path>
  //               </g>
  //             </svg>
  //           </span>`+
  //           "<a class='title' rel='noopener nofollow' href='" + item.url + "'" + "target='_blank'" +
  //           " title='" +
  //           item.title + "'" + ">" + rsBankEsQ(item.title) + "</a>" +
  //           "</div>" +
  //           "</li>";
  //       });
  //       rssList.innerHTML = rssListItems;
  //     } else {
  //       console.log("Request failed.  Returned status of " + rssX.status);
  //     }
  //   };
  //   rssX.send();
  // }
  // //-------------END OF RSSBANK--------------

  // ======= FIX HEIGHT OF THE PELIAKN BOXES =======
  const iframes = document.querySelectorAll(".pelikan_iframe");
  window.addEventListener("message", function (event) {
    if (event.data && event.data.height && event.data.src) {
      iframes.forEach(iframe => {
        if (iframe.src === event.data.src) {
          iframe.style.height = event.data.height + 'px';
        }
      });
    }
  });
  //----STICKY NOTIF----
  let closeNotif2 = false;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 600) {
      if (!closeNotif2) {
        const stickyNotify2 = document.querySelector('.sticky_notify2');
        if (stickyNotify2) {
          stickyNotify2.style.display = 'block';
        }
      }
    }
  });

  // Close sticky-notify
  window.closeStikyAd2 = function closeStikyAd2() {
    const stickyNotify2 = document.querySelector('.sticky_notify2');
    if (stickyNotify2) {
      stickyNotify2.style.display = 'none';
      closeNotif2 = true;
    }
  };

  //---------- STICKY ADV ----------
  if (document.querySelector(".position-c9")) {
    zxc_j9 = true;
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 250 && zxc_j9) {
        document.querySelector(".sticky_zxc_top").classList.replace("position_c9", "mobile_visible_fixed");
      }
    });
    document.querySelector("#close_adv").addEventListener('click', function () {
      document.querySelector(".sticky_zxc_top").classList.replace("mobile_visible_fixed", "position_c9");
      zxc_j9 = false;
    })
  }
  //---------- STICKY ADV ----------


})